<template>
  <div v-if="currentItem === 'all'" class="container-fluid container-add-item">
    <div class="row">
      <div class="col-12">
        <br />
        <h5>{{ $t("Set.AddItem.title") }}</h5>
        <br />
      </div>
    </div>
    <div class="row border-bottom">
      <template v-if="!onlyBasicModels">
        <div
          class="col-6 text-center"
          v-for="(item, index) in additionalItems"
          v-bind:key="index"
        >
          <a @click="addAdditionalItem(item.itemnumber)">
            <div class="crop-img">
              <img
                :src="
                  getApiHost +
                  '/v2/images/item/ffffff/600/600/' +
                  item.itemnumber.toUpperCase() +
                  '.jpg'
                "
                :ref="'addAdditionalItem_' + index"
                @error="
                  $refs['addAdditionalItem_' + index][0].src =
                    appUrl + '/img/assets/not-available.jpg'
                "
                :data-item="index"
                :alt="item.text"
                class="img-responsive"
                style="max-width: 10em; display: inline-block"
              />
            </div>
            <p class="text-center">{{ item.text }}</p>
          </a>
        </div>
      </template>
    </div>
    <div class="row add">
      <div class="col-12" v-if="error">
        <div class="alert alert-warning text-center">
          <h6 class="text-center" role="alert">
            {{ $t("Set.AddItem.addForm.error") }}
          </h6>
        </div>
      </div>
      <div class="col-12">
        <h5>{{ $t("Set.AddItem.addForm.title") }}</h5>
        <br />
        <fieldset class="form-group">
          <div class="input-group" style="width: 100%">
            <input
              type="text"
              v-model="newItemnumber"
              class="form-control"
              style="height: 2em; width: calc(100% - 8em)"
              @keyup.enter="addItem"
              @paste="isReplaceItem"
              @keyup="isReplaceItem"
              :placeholder="$t('Set.AddItem.addForm.placeholder')"
            />
            <br />
            <button
              class="btn btn-secondary"
              style="margin-top: 0; height: 3.2rem"
              @click="addItem"
            >
              {{ $t("Set.AddItem.addForm.button") }}
            </button>
          </div>
        </fieldset>
      </div>
      <div class="col-12 replace-note" v-if="showReplaceNote">
        <p>{{ $t("Set.AddItem.addForm.replaceNote") }}</p>
      </div>
    </div>
    <template v-if="showReplaceItem && set.items && set.items[0]">
      <div
        class="row item-row"
        v-for="(item, itemId) in set.items"
        v-bind:key="itemId"
      >
        <table id="TableSelectItems" class="table table-responsive">
          <tr>
            <td>
              <img
                v-if="item.description.jewelleryType == 5"
                :src="
                  appUrl +
                  '/img/assets/stones/exchange/stone_' +
                  item.description.stones.diamondStock.stoneform.toLowerCase() +
                  '.jpg'
                "
                :alt="item.itemnumber.toUpperCase()"
              />
              <img
                v-else
                :src="
                  getApiHost +
                  '/v2/images/item/ffffff/600/600/' +
                  item.itemnumber.toUpperCase().toUpperCase() +
                  '.jpg'
                "
                :alt="item.itemnumber.toUpperCase()"
              />
            </td>
            <td>
              <h5>
                <template v-if="item.name !== ''">
                  {{ item.name }}
                </template>
                <template v-else>
                  {{ $t("Set.SelectItem.item") }} {{ itemId + 1 }}
                </template>
              </h5>
              {{ item.itemnumber }}
            </td>
            <td>
              <button
                @click="replaceItem(itemId)"
                class="btn btn-secondary btn-sm btn-block btn-replace"
              >
                {{ $t("Set.AddItem.addForm.replaceItem") }}
              </button>
            </td>
          </tr>
        </table>
      </div>
    </template>
  </div>
</template>

<script>
import SetData from "@/vuex/SetData";
import Config from "@/vuex/Config";
import Validate from "@/assets/Helper/Validate";
import DAOSet from "@/assets/DAO/Set";
import Warehouse from "@/assets/DAO/Warehouse";
import ConvertItem from "@/assets/DAO/Item/ConvertItem";
import Logger from "@/assets/Helper/Logger";

export default {
  name: "SetAddItem",
  data() {
    return {
      appUrl: Config.getters.getAppUrl,
      newItemnumber: "",
      showReplaceItem: false,
      showReplaceNote: true,
      error: false,
      set: SetData.getters.getSet,
    };
  },
  props: ["additionalItems", "currentItem", "getApiHost"],
  mounted() {
    this.$ga.page("/additional_items/");
  },
  methods: {
    isReplaceItem: function (event) {
      if (event) {
        event.preventDefault();
      }

      this.newItemnumber = this.newItemnumber.trim();
      if (event && event.clipboardData) {
        if (this.newItemnumber !== "") {
          this.newItemnumber += event.clipboardData.getData("text");
        } else {
          this.newItemnumber = event.clipboardData.getData("text");
        }
      }

      this.newItemnumber = this.newItemnumber.trim().toUpperCase();

      if (
        Validate.isItemnumber(this.newItemnumber) &&
        !Validate.isSet(this.newItemnumber) &&
        !Validate.isWarehouse(this.newItemnumber)
      ) {
        this.showReplaceItem = true;
        this.showReplaceNote = false;
      } else {
        this.showReplaceItem = false;
        this.showReplaceNote = true;
      }
    },
    replaceItem: function (itemId) {
      this.newItemnumber = this.newItemnumber.trim().toUpperCase();

      ConvertItem.getItemnumber(this.newItemnumber)
        .then((result) => {
          if (typeof result === "object" && result[0]) {
            this.newItemnumber = result[0];
            let posSize = result[0].indexOf(":");
            if (posSize > 0) {
              this.newItemnumber = result[0].substr(0, posSize);
            }
            for (let key in this.set.items) {
              if (key == itemId) {
                SetData.dispatch("setItem", {
                  key: key,
                  id: this.newItemnumber,
                }).then(() => {
                  this.newItemnumber = "";
                  this.update(false);
                });
              }
            }
          } else {
            this.update(true);
          }
        })
        .catch((error) => {
          this.update(true);
          Logger.log(error);
        });
    },
    addItem: function () {
      this.newItemnumber = this.newItemnumber.trim().toUpperCase();

      if (Validate.isSet(this.newItemnumber)) {
        DAOSet.getItemnumbers(this.newItemnumber, false);

        this.newItemnumber = "";
        this.update(false);
      } else if (
        Validate.isWarehouse(this.newItemnumber) &&
        Config.getters.isShopLoginActive
      ) {
        Warehouse.get(this.newItemnumber, Config.getters.getActiveShop);
      } else if (Validate.isItemnumber(this.newItemnumber)) {
        ConvertItem.getItemnumber(this.newItemnumber)
          .then((result) => {
            if (typeof result === "object" && result[0]) {
              SetData.dispatch("addItem", result[0]).then(() => {
                this.newItemnumber = "";
                this.update(false);
              });
            } else {
              this.update(true);
            }
          })
          .catch((error) => {
            this.update(true);
            Logger.log(error);
          });
      } else {
        this.update(true);
      }
    },
    update: function (isError) {
      this.error = isError;
      if (this.error === false) {
        if (SetData.getters.getSetId != "" && this.set.items.length > 1) {
          SetData.dispatch("setShowSetImage", true).catch((error) => {
            Logger.error(error);
          });
        }

        this.$parent.$parent["reset3d"]();
        this.$parent.$parent["setCurrentItem"]("overview");
        setTimeout(() => {
          this.$root.$emit("updateViewer");
        }, 750);
      } else {
        setTimeout(() => {
          this.error = false;
        }, 2000);
      }
    },
    addAdditionalItem: function (itemnumber) {
      this.newItemnumber = itemnumber;
      this.addItem();
    },
  },
  computed: {
    onlyBasicModels: function () {
      for (let itemIdx in this.set.items) {
        if (
          typeof this.set.items[itemIdx].description === "object" &&
          !this.set.items[itemIdx].description.isBasicModel
        ) {
          return false;
        }
      }
      return true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#app {
  .container-add-item {
    background-color: $white;
    padding: 2.5rem 2.5rem 4rem 2.5rem;
  }

  .item-row {
    border-bottom: solid 0.05em $borderColor;
    cursor: pointer;

    h5 {
      margin-top: 2.5rem;
    }

    img {
      width: 6em;
      height: auto;
    }
  }

  input {
    margin-bottom: 0.5rem;
  }

  .btn {
    border-color: #cccccc;
    margin-bottom: 1rem;
  }

  .replace-note {
    color: $pink;
    font-weight: bold;
  }

  #TableSelectItems {
    border: none;

    img {
      width: 6em;
      height: auto;
    }

    tr {
      td {
        vertical-align: middle;

        .btn-replace {
          margin-top: 2.5rem;
        }

        .icon {
          margin: 0.5rem 0.5rem 1rem 0;
          display: inline-block;
          max-width: 1.5rem;
          text-align: center;

          &:first-child {
            margin-top: 1.5rem;
          }
        }
      }

      td:first-child {
        padding-left: 1.5rem;
        padding-right: 1.5rem;
        text-align: left;
        width: 25%;
      }

      td:nth-child(2) {
        width: 65%;
      }

      td:last-child {
        padding-left: 1.5rem;
        padding-right: 1.5rem;
      }
    }
  }
}
</style>
